import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import ModalContact from '@components/Evaluator/ModalContact';
import JustificationModal from '@components/JustificationModal';

import { updateEvaluator } from '@actions/evaluators';
import { sendActionToBitacora  } from '@actions/bitacora';

class ContactInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnSubmitLoading: false,
      showModalContact: {
        isVisible: false,
        title: '',
        nombre: '',
        telefono: '',
        correo: '',
        label: '',
        continueAction: null,
      },
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    };
  }

  onAddContactModal = () => {
    const { t } = this.props
    this.setState({
      showModalContact: {
        isVisible: true,
        value: '',
        title: t('Agregar contacto'),
        btnOkLabel: t('Agregar'),
        continueAction: (data, justification) => this.addContact(data, justification),
      },
    });
  }

  addContact = async (data, justification) => {
    const { updateEvaluator, loadListEvaluators, _contacto, toalAction, sendActionToBitacora } = this.props
    const newContacts = [ ..._contacto ]
    newContacts.push({... data})
    const response = await updateEvaluator({contacto: newContacts})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actEvaluador',
        reason: `${data.correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      toalAction()
      loadListEvaluators()
    }
    return this.setState({ btnSubmitLoading: false });
  }

  onEditContactModal = (data, rowIndex) => {
    const { t } = this.props
    this.setState({
      showModalContact: {
        isVisible: true,
        nombre: data.nombre,
        correo: data.correo,
        telefono: data.telefono,
        title: t('Datos del contacto'),
        btnOkLabel: t('Guardar'),
        continueAction: (data, justification) => this.editContact(data, rowIndex, justification),
      },
    });
  }

  editContact = async (data, rowIndex, justification) => {
    const { updateEvaluator, loadListEvaluators, _contacto, toalAction, sendActionToBitacora } = this.props
    const editContacts = [ ..._contacto ]
    editContacts[rowIndex] = { ...data }
    
    const response = await updateEvaluator({contacto: editContacts})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actEvaluador',
        reason: `${data.correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      toalAction()
      loadListEvaluators()
    }
    return this.setState({ btnSubmitLoading: false });
  }

  onConfirmDeleteContact = (data, rowIndex) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: data.nombre}),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteContact(rowIndex, justification),
      },
    });
  }

  onDeleteContact = async (rowIndex, justification) => {
    const { updateEvaluator, loadListEvaluators, _contacto, toalAction, sendActionToBitacora } = this.props
    const deleteContacts = [ ..._contacto ]
    deleteContacts.splice(rowIndex, 1)

    const response = await updateEvaluator({contacto: deleteContacts})
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actEvaluador',
        reason: `${_contacto[rowIndex].correo} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      toalAction()
      loadListEvaluators()
    }
    return this.setState({ btnSubmitLoading: false });
  }

  onHideModalContact = () => {
    this.setState({
      showModalContact: {
        isVisible: false,
      },
    });
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  templateEdit = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onEditContactModal(node, detail.rowIndex)}
      />
    </div>
  );

  templateDelete = (node, detail) => (
   <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-trash"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onConfirmDeleteContact(node, detail.rowIndex)}
      />
    </div>
  );

  render() {
    const { t, _contacto } = this.props;
    const { btnSubmitLoading, showModalContact, showModalJustification } = this.state;

    return (
      <>
        <div className="p-col-12 p-mt-2">
          <DataTable
            value={_contacto}
            lazy
            className="table-languages"
            emptyMessage={t("No existen datos de contacto")}
            showGridlines
            stripedRows
            // paginator={!!allEmails.length}
            // rows={lazyParams.rows}
            // totalRecords={allEmails.length}
            // first={lazyParams.first}
            // onPage={this.onPage}
          >
            <Column
              header={t('Nombre')}
              field="nombre"
              body={this.columnResponsive}
            />
            <Column
              header={t('Télefono')}
              field="telefono"
              body={this.columnResponsive}
              // className="column-max p-text-center-lg"
            />
            <Column
              header={t('Correo electrónico')}
              field="correo"
              body={this.columnResponsive}
              // className="column-action p-mr-4"
            />
            <Column
              header={t('Editar')}
              body={this.templateEdit}
              className="column-action p-text-center-lg"
            />
            <Column
              header={t('Eliminar')}
              body={this.templateDelete}
              className="column-action p-text-center-lg"
            />
          </DataTable>
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-end">
            <Button
              label={t('Agregar contacto')}
              type="button"
              className="p-button-primary"
              onClick={this.onAddContactModal}
              loading={btnSubmitLoading}
            />
          </div>
          { showModalContact.isVisible && (
            <ModalContact
              display={showModalContact.isVisible}
              title={showModalContact.title}
              nombre={showModalContact.nombre}
              correo={showModalContact.correo}
              telefono={showModalContact.telefono}
              btnOkLabel={showModalContact.btnOkLabel}
              label={showModalContact.label}
              onHidden={() => this.onHideModalContact()}
              onContinueAction={showModalContact.continueAction}
            />
          )}
          <JustificationModal
            display={showModalJustification.isVisible}
            title={showModalJustification.title}
            description={showModalJustification.description}
            label={showModalJustification.label}
            onHidden={() => this.onHideModal()}
            onContinueAction={showModalJustification.continueAction}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _contacto: state.evaluator.contacto,
});

const mapDispatchToProps = {
  updateEvaluator,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ContactInformation);
